// extracted by mini-css-extract-plugin
module.exports = {"active":"active__3jtR7","inactive":"inactive__1hHCF"};